/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CrmEntityType} from '../models/CrmEntityType';
import type {CrmSyncType} from '../models/CrmSyncType';
import type {Error} from '../models/Error';

export interface SyncAccountUsersCrmId$Request {
    accountId: number;
    entityType: CrmEntityType;
    crmType: CrmSyncType;
    pbIds?: File | File[];
}

export interface SyncAccountUsersCrmId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const syncAccountUsersCrmIdRequest = createAction<PayloadData<void, SyncAccountUsersCrmId$Request>>('ACCOUNT_USERS_CRM_ID_SYNC__SYNC_ACCOUNT_USERS_CRM_ID__REQUEST');
export const syncAccountUsersCrmIdSuccess = createAction<PayloadData<void, SyncAccountUsersCrmId$Request>>('ACCOUNT_USERS_CRM_ID_SYNC__SYNC_ACCOUNT_USERS_CRM_ID__SUCCESS');
export const syncAccountUsersCrmIdFailure = createAction<PayloadData<Error, SyncAccountUsersCrmId$Request, true>>('ACCOUNT_USERS_CRM_ID_SYNC__SYNC_ACCOUNT_USERS_CRM_ID__FAILURE');

export const syncAccountUsersCrmIdActions = [
    syncAccountUsersCrmIdRequest,
    syncAccountUsersCrmIdSuccess,
    syncAccountUsersCrmIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {CrmEntityType} meta.entityType
 * @param {CrmSyncType} meta.crmType
 * @param {any} [meta.pbIds]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const syncAccountUsersCrmId = (meta: SyncAccountUsersCrmId$Request, config?: SyncAccountUsersCrmId$Config) => {
    const TRANSPORT_GET_PARAMS = {
        entityType: meta.entityType,
        crmType: meta.crmType,
    };
    const TRANSPORT_REQUEST_FILE = {
        pbIds: meta.pbIds,
    };
    return {
        UPLOAD_FILE: {
            types: syncAccountUsersCrmIdActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/users-crm-id-sync`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

